import React, { useEffect } from "react";
import PriceSection from "../components/Order_Page/PriceSection";
import Footer from "../components/Shared/Footer";
import Navbar from "../components/NavBar/Navbar";
import Breadcrumbs from "../components/Article_Display_Page/Breadcrumbs";
import { useAvailableItemConfigContext } from "../hooks/useContext/useAvailableItemConfigContext";
import { useTheme } from "@mui/material/styles";
import useFetchOpenStatus from "../hooks/useFetchOpenStatus";

function Order() {
  const { itemConfigs, dispatch } = useAvailableItemConfigContext();
  const theme = useTheme();

  useFetchOpenStatus();

   useEffect(() => {
      const fetchAllItemConfigs = async () => {
        const response = await fetch(process.env.REACT_APP_SERVER_URL + "/api/itemconfigs/available");
        const json = await response.json();
        if (response.ok) {
          dispatch({ type: "SET_AVAILABLEITEMCONFIG", payload: json });
        } else {
          console.log('error on Order.js page');
          // window.location.reload();
        }
      };
      
      fetchAllItemConfigs();
      
    }, [dispatch]);

  return (
    <div style={{backgroundColor: theme.palette.common.background}}>
      <Navbar />
      <Breadcrumbs title="orderOnline" />
      <PriceSection items={itemConfigs}/>
      <Footer />
    </div>
  );
}

export default Order;
